import * as React from 'react';

const WorkOrdersIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <rect width="32" height="32" rx="16" fill="#E99921" />
    <path
      d="M23.4997 11.4173C23.4997 13.0257 22.1914 14.334 20.583 14.334C20.2414 14.334 19.9164 14.2673 19.6164 14.159L10.133 23.634L8.36636 21.8673L14.5414 15.6923L13.058 14.209L12.4664 14.8007L11.2914 13.6257V15.984L10.6997 16.5757L7.74969 13.6257L8.34136 13.034H10.6914L9.51636 11.859L12.4664 8.90898C13.4414 7.93398 15.0247 7.93398 15.9997 8.90898L14.233 10.6757L15.408 11.8507L14.8164 12.4423L16.2997 13.9257L17.8414 12.384C17.733 12.084 17.6664 11.759 17.6664 11.4173C17.6664 9.80898 18.9747 8.50065 20.583 8.50065C21.0664 8.50065 21.5164 8.63398 21.9164 8.84232L19.6664 11.0923L20.908 12.334L23.158 10.084C23.3664 10.484 23.4997 10.934 23.4997 11.4173Z"
      fill="white"
    />
    <path
      d="M17.4852 18.6432L19.253 16.8755L24.2498 21.8723L22.482 23.6401L17.4852 18.6432Z"
      fill="white"
    />
  </svg>
);

export default WorkOrdersIcon;
